import { Box, Button, Flex, Grid } from '@chakra-ui/react'
import { motion } from 'framer-motion'

export const MotionButton = motion(Button)
export const MotionGrid = motion(Grid)
export const MotionFlex = motion(Flex)
export const MotionBox = motion(Box)
